import { createContext, FC, PropsWithChildren, useCallback, useContext, useEffect, useRef } from 'react'
import LayoutHost from './host'
import { ILayoutManagerState, LayoutManagerRenderFunctionType, ILayoutManagerConsumerConfig } from './types'

const LayoutContext = createContext<(state: ILayoutManagerState<string>) => void>(() => {
	/* */
})

export function createLayoutManager<T extends string = string>(renderFn: LayoutManagerRenderFunctionType<T>) {
	const Provider: FC<PropsWithChildren> = ({ children }) => {
		const ref = useRef<LayoutHost<T>>(null)
		const update = useCallback((state: ILayoutManagerState) => {
			if (ref.current) {
				ref.current.setState(state as ILayoutManagerState<T>)
			}
		}, [])

		return (
			<LayoutContext.Provider value={update}>
				<LayoutHost ref={ref} renderFn={renderFn} />
				{children}
			</LayoutContext.Provider>
		)
	}

	const Consumer: FC<PropsWithChildren<ILayoutManagerConsumerConfig<T>>> = ({
		contentKey,
		type,
		children,
		systemMessage,
	}) => {
		const update = useContext(LayoutContext)
		useEffect(() => {
			update({ contentKey, type, children, systemMessage })
		})
		return null
	}

	return { Provider, Consumer }
}
